import JwtService from "@/common/jwt.service";

export default function auth(to, from, next) {
  if (!JwtService.getUser()) {
    return next("/login");
  } else {
    const user = JSON.parse(JwtService.getUser());
    let role = user.roles[0].role;
    if (role === "streamer") {
      return next("/live_stream");
    } else if (role === "content_editor") {
      return next("/newsfeed");
    }
  }
  return next();
}
